import authRules from '../authRules.js';

const assignments = (user) => {
  const { assignments } = user.securityLevels;
  if (assignments >= authRules.assignments.assignments) {
      return true;
  } else {
      return false;
    }
  }

export default assignments;
